import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import 'rc-pagination/assets/index.css'
import { SWRConfig } from 'swr'
import { getToken } from './lib/token';
import ErrorBoundary from './components/ErrorBoundary';

ReactDOM.render(
	<ErrorBoundary>
		<SWRConfig
			value={{
				shouldRetryOnError: false,
				/**
				 * Retrive the data fetch it in the API. 
				 * @param {string} path The resource to request.
				 * @param {string} [method=GET] The method to use in the request. 
				 * @param {string} [body] The body required in some request.
				 * @returns 
				 */
				fetcher: async (path: string, method: string = 'GET', body?: string) => {
					try {
						const options = {
							method,
							headers: {
								'Content-Type': 'application/json',
								'Authorization': `Bearer ${getToken(path)}`
							},
							...(body && { body })
						}

						const response = await fetch(path, options);

						if (!response.ok) {
							const message = `An error has occured: ${response.status}`;
							throw new Error(message);
						}

						const data = await response.json();
						return data;

					} catch (error) {
						throw error
					}

				}
			}}
		>
			<React.StrictMode>
				<Router>
					<App />
				</Router>
			</React.StrictMode>
		</SWRConfig>
	</ErrorBoundary>,
	document.getElementById('app-root')
);
